import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  BarChart3,
  FileText,
  Upload,
  LineChart,
  User,
  Users,
  Settings,
  Calculator,
  Target,
  Brain,
  Calendar,
  Truck,
  Shield,
  GitBranch,
  Layout,
  FileCheck,
  Droplet,
  ClipboardCheck,
} from 'lucide-react';

const menuItems = [
  { icon: <FileText className="h-5 w-5" />, label: 'ESG Reporting', path: '/dashboard/reporting' },
  { icon: <BarChart3 className="h-5 w-5" />, label: 'ESG Metrics', path: '/dashboard/metrics' },
  { icon: <Layout className="h-5 w-5" />, label: 'Custom Dashboard', path: '/dashboard/custom-dashboard' },
  { icon: <Calculator className="h-5 w-5" />, label: 'Carbon Calculator', path: '/dashboard/calculator' },
  { icon: <Droplet className="h-5 w-5" />, label: 'Water Management', path: '/dashboard/water' },
  { icon: <Target className="h-5 w-5" />, label: 'Goals & Targets', path: '/dashboard/goals' },
  { icon: <Truck className="h-5 w-5" />, label: 'Supply Chain', path: '/dashboard/supply-chain' },
  { icon: <Shield className="h-5 w-5" />, label: 'Compliance', path: '/dashboard/compliance' },
  { icon: <ClipboardCheck className="h-5 w-5" />, label: 'Compliance Evaluation', path: '/dashboard/compliance-evaluation' },
  { icon: <GitBranch className="h-5 w-5" />, label: 'Scenario Planning', path: '/dashboard/scenarios' },
  { icon: <Users className="h-5 w-5" />, label: 'Stakeholder Portal', path: '/dashboard/stakeholder' },
  { icon: <Brain className="h-5 w-5" />, label: 'AI Insights', path: '/dashboard/ai-insights' },
  { icon: <Calendar className="h-5 w-5" />, label: 'Automated Reports', path: '/dashboard/reports' },
  { icon: <Upload className="h-5 w-5" />, label: 'Data Import', path: '/dashboard/import' },
  { icon: <LineChart className="h-5 w-5" />, label: 'Data Analysis', path: '/dashboard/analysis' },
];

const bottomMenuItems = [
  { icon: <User className="h-5 w-5" />, label: 'Profile', path: '/dashboard/profile' },
  { icon: <Users className="h-5 w-5" />, label: 'User Management', path: '/dashboard/users' },
  { icon: <Settings className="h-5 w-5" />, label: 'Settings', path: '/dashboard/settings' },
  { icon: <FileCheck className="h-5 w-5" />, label: 'Audit Logs', path: '/dashboard/audit-logs' },
];

export default function AdminSidebar() {
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <aside data-tour="sidebar-nav" className="fixed left-0 top-16 h-[calc(100vh-4rem)] w-64 bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 transition-colors">
      <div className="flex flex-col h-full">
        <div className="flex-1 py-6 px-4">
          <nav className="space-y-1">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors ${
                  isActive(item.path)
                    ? 'bg-green-50 text-green-800 dark:bg-green-900 dark:text-green-100'
                    : 'text-gray-700 hover:bg-gray-50 dark:text-gray-300 dark:hover:bg-gray-700'
                }`}
              >
                {React.cloneElement(item.icon, {
                  className: `${
                    isActive(item.path)
                      ? 'text-green-800 dark:text-green-100'
                      : 'text-gray-400 dark:text-gray-500'
                  } mr-3 h-5 w-5`,
                })}
                {item.label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="p-4 border-t border-gray-200 dark:border-gray-700">
          <nav className="space-y-1">
            {bottomMenuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                {...(item.path === '/dashboard/settings' ? { 'data-tour': 'sidebar-settings' } : {})}
                className={`flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors ${
                  isActive(item.path)
                    ? 'bg-green-50 text-green-800 dark:bg-green-900 dark:text-green-100'
                    : 'text-gray-700 hover:bg-gray-50 dark:text-gray-300 dark:hover:bg-gray-700'
                }`}
              >
                {React.cloneElement(item.icon, {
                  className: `${
                    isActive(item.path)
                      ? 'text-green-800 dark:text-green-100'
                      : 'text-gray-400 dark:text-gray-500'
                  } mr-3 h-5 w-5`,
                })}
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </aside>
  );
}